
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.47 30.917L30.734 18.46a12.61 12.61 0 001.072-5.097C31.806 6.374 26.14.708 19.15.708c-6.99 0-12.656 5.667-12.656 12.655 0 1.858.403 3.62 1.121 5.209L.85 30.912a1.152 1.152 0 001.267 1.675l5.778-1.326 1.977 5.508a1.15 1.15 0 002.098.155l5.888-10.97a12.786 12.786 0 002.477.007l6.016 10.971a1.15 1.15 0 002.093-.164l1.978-5.508 5.778 1.326c.443.107.9-.065 1.173-.425a1.15 1.15 0 00.097-1.244zm-26.305 2.64l-1.448-4.035a1.147 1.147 0 00-1.341-.732l-4.274.98 4.871-8.884a12.674 12.674 0 006.527 4.597l-4.335 8.074zM29.94 28.79a1.146 1.146 0 00-1.341.732l-1.458 4.064-4.43-8.078a12.675 12.675 0 006.673-4.702l4.85 8.968-4.294-.984z","fill":"#CECDD2"}}),_c('path',{attrs:{"d":"M15.32 17.498l2.946-3.077a41.474 41.474 0 001.385-1.502c.292-.35.501-.652.627-.905.127-.262.19-.53.19-.802 0-.447-.141-.802-.423-1.064-.282-.273-.651-.409-1.108-.409-.477 0-.885.136-1.225.409-.33.262-.574.651-.73 1.166l-1.735-.54c.117-.563.35-1.054.7-1.472a3.64 3.64 0 011.327-.992 4.048 4.048 0 011.663-.35c.69 0 1.302.131 1.837.394.535.253.948.612 1.24 1.079.301.457.452.982.452 1.575 0 .583-.16 1.152-.481 1.706-.311.545-.822 1.186-1.532 1.925l-2.552 2.684h4.71V19H15.32v-1.502z","fill":"#000"}})])
          )
        }
      }
    